// 全局初始化插件
// 迁移自 main.js 中的 Vue.prototype 全局属性注册

import Vue from 'vue'

export default (context) => {
  // 服务端+客户端都需要的属性
  Vue.prototype.$maxImgSize = 500
  Vue.prototype.$baseUrl = 'https://api.chaoangoods.com'
  Vue.config.productionTip = false

  // 仅在客户端执行（localStorage 是浏览器 API）
  if (process.client) {
    if (!localStorage.getItem('rate')) {
      localStorage.setItem('rate', 'USD')
    }
    if (!localStorage.getItem('symbol')) {
      localStorage.setItem('symbol', '$')
    }
    Vue.prototype.$symbol = localStorage.getItem('symbol')
  } else {
    // 服务端默认值
    Vue.prototype.$symbol = '$'
  }
  // $message 由 Element UI 插件提供，无需覆盖
}
